<template>
  <v-container
    id="analyse"
  >
    <v-row>
      <v-col
        cols="8"
        md=8
        class="breadcrumbs"
      >
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <app-city-combobox
          :filter="filter"
        ></app-city-combobox>
      </v-col>

      <v-col>
        <app-consultant-combobox
          :filter="filter"
          v-if="isAdmin"
        ></app-consultant-combobox>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataInicialString"
          v-mask="'##/##/####'"
          label="Data Inicial"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-text-field
          v-model="filter.dataFinalString"
          v-mask="'##/##/####'"
          label="Data Final"
          clearable
        ></v-text-field>
      </v-col>

      <v-col>
        <v-select
          v-model="filter.statusRelatorioId"
          item-text="text"
          item-name="value"
          :items="statusRelatorios"
          label="Status dos Relatórios"
        >
        </v-select>
      </v-col>

      <v-col>
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="loadReports()"
        >
          <span>Filtrar</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="reports"
          item-key="relatorioAdministrativoId"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr
              :class="{ 'evidenciada': props.item.statusRelatorioId === 2 || props.item.statusRelatorioId === 4, 'evidenciar':  props.item.statusRelatorioId === 3, 'rejeitada':  props.item.statusRelatorioId === 1 }"
               @click="clickRow(props.item)"
            >
              <td>{{ props.item.relatorioAdministrativoId }}</td>
              <td>{{ props.item.usuario.nome }}</td>
              <td>{{ props.item.municipio.nome }}</td>
              <td>{{ props.item.criacao | moment("DD/MM/YYYY") }}</td>
              <td>
                  <app-modal-delete
                    v-if="isAdmin && props.item.statusRelatorioId !== 4"
                    :relatorio="props.item"
                    @onDelete="loadReports"
                  >
                    <template v-slot:title>
                      Deletar Processo administrativo
                    </template>
                  </app-modal-delete>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span>
              Nenhum processo de pagamento retornado
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <app-modal-analyse-administrative-report
      :dialog="openModal"
      :id="selectedReport.relatorioAdministrativoId"
      @onCloseReport="onCloseModal"
      v-if="isAdmin"
    >
    </app-modal-analyse-administrative-report>
  </v-container>
</template>

<script>
import { administrativeReportAPI } from '@/modules/administrative-report'
import { mapActions, mapGetters } from 'vuex'
import { AppConsultantCombobox } from '@/modules/user'
import { AppCityCombobox } from '@/modules/city'
import AppModalAnalyseAdministrativeReport from './ModalAnalyse'
import AppModalDelete from './../components/ModalDelete'

export default {
  components: {
    AppCityCombobox,
    AppConsultantCombobox,
    AppModalAnalyseAdministrativeReport,
    AppModalDelete
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'user'
    ])
  },
  data () {
    return {
      headers: [
        {
          text: '#',
          value: 'relatorioadministrativoId'
        },
        {
          text: 'Usuário',
          value: 'usuario.nome'
        },
        {
          text: 'Município',
          value: 'municipio.nome'
        },
        {
          text: 'Criação',
          value: 'criacao'
        }
      ],
      reports: [],
      filter: {
        statusRelatorioId: 1
      },
      selectedReport: {},
      openModal: false,
      solutions: [],
      modalConfirmFinishSolution: false,
      statusRelatorios: [
        { text: 'Não Analisado', value: 1 },
        { text: 'Aprovado', value: 2 },
        { text: 'Inserido em Processo de Pagamento', value: 4 },
        { text: 'Reprovado', value: 3 },
        { text: 'Todos', value: null }
      ],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: 'cidade'
        },
        {
          text: 'Análise de Relatórios Administrativos',
          disabled: true,
          href: 'analisar-relatorios-administrativos'
        }
      ]
    }
  },
  mounted () {
    this.loadReports()
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadReports () {
      this.openModal = false
      this.modalConfirmFinishSolution = false
      if (this.filter.municipio) this.filter.municipioId = this.filter.municipio.municipioId
      else this.filter.municipioId = null
      if (!this.isAdmin) this.filter.usuarioId = this.user.usuarioId
      this.setLoading(true)
      administrativeReportAPI.getByFilter(this.filter)
        .then(resp => {
          this.reports = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao listar relatórios')
        })
    },
    clickRow (data) {
      this.openModal = true
      this.selectedReport = data
    },
    onCloseModal () {
      this.loadReports()
    },
    removerProcessoDePagamento (relatorio) {
      administrativeReportAPI.delete(relatorio.item.relatorioAdministrativoId)
        .then(resp => {
          this.loadReports()
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao excluir relatorio administrativo')
        })
    }
  }
}
</script>
